import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import WhyPWAStats from "./components/WhyPWAStats";
import PromotionSection from "./components/PromotionSection";
import StatsSection from "./components/StatsSection";
import RosterSection from "./components/RosterSection";
import PreviousEventsSection from "./components/PreviousEventsSection";
import RadioSection from "./components/RadioSection";
import CtaSection from "./components/CtaSection";
import VenueSection from "./components/VenueSection";

export default function Home() {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <HeroSection />
      <WhyPWAStats />
      <PromotionSection />
      <StatsSection />
      <RosterSection />
      <PreviousEventsSection />
      <RadioSection />
      <CtaSection />
      <VenueSection />
      <Footer />
    </div>
  );
}
